module.exports = __webpack_public_path__ + "static/IBMPlexSans-Medium-dc6ac8f0f85ca4a40e144250b936cabb.woff2";